/** @jsx jsx */
import { jsx } from '@compiled/react';
import ProfileCard from '@atlassian/jira-profilecard-next/src/ui/profilecard/sync-experiment.tsx';
import type { User } from '../../model/index.tsx';
import AvatarTitleCell from '../avatar-title-cell/view.tsx';

export type Props = {
	user: User | null;
	// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
	onClick?: () => void | null | undefined;
	isDeleting?: boolean;
};

export default function UserCell(props: Props): JSX.Element | null {
	const { user, isDeleting } = props;

	if (!user) {
		return null;
	}

	const { accountId, displayName, avatarUrl } = user;
	const content = (
		<AvatarTitleCell displayName={displayName} avatarUrl={avatarUrl} isDeleting={isDeleting} />
	);

	return (
		<ProfileCard accountId={accountId} prepopulatedData={{ fullName: displayName }}>
			{content}
		</ProfileCard>
	);
}
